<template>
  <ValidationProvider rules="required:#label-declaration">
    <input
      :id="`declaration${index}`"
      v-model="checked"
      true-value="true"
      false-value="false"
      value="true"
      type="checkbox"
      :name="`Declaration ${index}`"
    />
    <slot></slot>
  </ValidationProvider>
</template>
<script>
export default {
  computed: {
    checked: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  props: {
    index: String,
    value: Boolean
  }
}
</script>